import { PAYMENT_PROCESSOR } from 'components/UserPaymentForm/utils';

import useRenewWithCardOnFileSquare from './useRenewWithCardOnFileSquare';
import useRenewWithCardOnFileStripe from './useRenewWithCardOnFileStripe';
import useGetCurrentUserPaymentProcessor from './useGetCurrentUserPaymentProcessor';

const useRenewWithCardOnFile = ({ member, setPaymentStatus, memberTypes, renewInfo }) => {
	const getCurrentUserPaymentProcessor = useGetCurrentUserPaymentProcessor();

	const paymentProcessor = getCurrentUserPaymentProcessor();

	const { handler: renewWithCardOnFileSquare, isRenewLoading: isRenewLoadingSquare } = useRenewWithCardOnFileSquare({
		member,
		setPaymentStatus
	});

	const { handler: renewWithCardOnFileStripe, isRenewLoading: isRenewLoadingStripe } = useRenewWithCardOnFileStripe({
		memberTypes,
		renewInfo,
		setPaymentStatus
	});

	const renewWithCardOnFile =
		paymentProcessor === PAYMENT_PROCESSOR.stripe ? renewWithCardOnFileStripe : renewWithCardOnFileSquare;

	return {
		isLoading: isRenewLoadingSquare || isRenewLoadingStripe,
		renewWithCardOnFile
	};
};

export default useRenewWithCardOnFile;
